import type { TOC } from '@ember/component/template-only';

import WizardCreateBlockComponent from 'webapp/components/wizard/create-block';

const WizardCreateBlockRouteTemplate: TOC<object> = <template>
	<WizardCreateBlockComponent />
</template>;

export default WizardCreateBlockRouteTemplate;
